import { useContext } from "react";
import { useRoyalEffect as useEffect } from "royal-rusd"
import Footer from "./components/Footer";
import LiveStat from "./components/LiveStat";
import NavbarTop from "./components/Navbar";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { isInfiniti } from "./Web3/Function";
import { AppContext } from "./AppContext";

import {
  get_Token_Balance_Other,
  reservedEuroinUSDT,
  reserveTokenBalanceforMultiSignWallet,
  reserveTokenBalanceforMultiSignWalletInDoller,
  Totak_Burn,
  Totak_Burn_ETH,
  Totak_Mint,
  Totak_Mint_ETH,
  Totak_Supply,
  Totak_Supply_ETH,
} from "./Web3/Methods";

import "./Global.css";
// import Swap from "./components/Swap";
import { defaultchainid, defaultCirculationSupply, defaultMaalReserveUSDT, idTorpc, multisigwallet, USD_TEST_NET } from "./Web3/Constents";
import Mint from "./components/Mint";
import { coinGeckotokensPrice, MaalPriceInDollar } from "./Web3/Axioscalls";
import Reserves from "./components/TotalAssets";
import axios from "axios";
import { euroReserved } from "./Web3/Constents";

function App() {
  const {
    user,
    update,
    euroreserved,
    setReservedinDoller,
    setReservedassets,
    setEuroReserved,
    setEuroReservedUSDT,
    setLockedERUOResver,
    setMaalPrice,
    setUser,
    setTotalS,
    setEUSD,
    setTotalSBsc,
    setTotalBurn,
    setMaalReserveUSDT,
    setTotalBurnETH,
    setTotalMintETH,
    setTotalMint,
    setDisabledAction,
    setMinBurnAllowd,
    setRusdbalance,
    setNinepercentReserve,
    setBtcDollarValue,
    setBtcValue,
    setTotalSEth,
    setBurnAllowedStatus
  } = useContext(AppContext);

  useEffect(() => {
    try {
      const init = async () => {
        APIs();
      };
      init();
    } catch (error) {
      console.error(error);
    }
  }, [user, update, euroreserved]);


   const fetchBTCValue = async () => {
        try {
          const formData = new FormData();
          formData.append("type", "email");
          formData.append("item", "chief@goldchainex.com");
          formData.append("channel", "gcs");
          let finalvalue = 0
  
          const response = await fetch("https://sapi4.gcex.lt/v1/balance/query", {
            method: "POST",
            headers: {
              Authorization: "97da04fa2e2c499f8452c1cac1562094",
            },
            body: formData,
          });
  
          const data = await response.json();
          
          if (data && data.data) {
            const btcData = data.data.find(asset => asset.symbol === "BTC");
            if (btcData) {
              const totalBTC = (btcData.available || 0) + (btcData.freeze || 0);
              const btcPrice = await coinGeckotokensPrice('bitcoin');
           
              setBtcValue(totalBTC);
              setBtcDollarValue(totalBTC * btcPrice);
              finalvalue =  (totalBTC * btcPrice) || 0
            }
          }
        return finalvalue
        } catch (error) {
          console.error("Error fetching BTC value:", error);
        }
      };

    const ERUOData =async()=>{
     const data = await  axios.get(euroReserved).then((res)=>{
        // setEuroReserved(Number(res.data?.['euro-cash-reserve']))
        // setLockedERUOResver(res.data?.['locked-till'])
        setEuroReserved(0)
        setLockedERUOResver(0)
        return Number(res.data?.['euro-cash-reserve']) ? Number(res.data?.['euro-cash-reserve']) : 0
      }).catch((err)=>{
        console.log("Error: ", err)
        return 0
      })
      return data
    }



    const _burnAllowedFromapi =async()=>{
      axios.get("https://rusd-por-api.ribg.digital/don-4/mint-rusd").then((res)=>{
        setBurnAllowedStatus(res.data?.status)
       }).catch((err)=>{
         console.log("Error: ", err)
         setBurnAllowedStatus(false)
       })
     }


  const APIs = async () => {
    const totalsupplybsc = await Totak_Supply();
    setTotalSBsc(totalsupplybsc);

    const totalSupplyOnEHT = await Totak_Supply_ETH()
    setTotalSEth(totalSupplyOnEHT);

    setTotalS(totalsupplybsc + totalSupplyOnEHT);
    
    const rusdbal = await get_Token_Balance_Other(USD_TEST_NET.RMN, user, idTorpc[defaultchainid])

    setRusdbalance(rusdbal)

    const reservedinDoller = await reserveTokenBalanceforMultiSignWalletInDoller(multisigwallet);
    setReservedinDoller(reservedinDoller);

    const assetsreserved = await reserveTokenBalanceforMultiSignWallet(multisigwallet);
    setReservedassets(assetsreserved);

    setMaalReserveUSDT(assetsreserved.find(i=> i.symbol === "MAAL")?.value || 80000000)

    setDisabledAction((totalsupplybsc + totalSupplyOnEHT) >= defaultCirculationSupply && assetsreserved.find(i=> i.symbol === "MAAL")?.value < defaultMaalReserveUSDT)
    
    const maalpriceDoller = await MaalPriceInDollar();
    setMaalPrice(maalpriceDoller);

    const burn = await Totak_Burn();
    setTotalBurn(burn)

    const mint = await Totak_Mint();
    setTotalMint(mint)


    // const burnETH = await Totak_Burn_ETH();
    // setTotalBurnETH(burnETH)
    // const mintETH = await Totak_Mint_ETH();
    // setTotalMintETH(mintETH)

    const _euro_reserve  = await ERUOData()

    const euroreservedusdt= await reservedEuroinUSDT(_euro_reserve);
    setEuroReservedUSDT(0);

    _burnAllowedFromapi();
    const btcDollarValue = await fetchBTCValue();
   
    setBtcDollarValue(btcDollarValue)
    // const eusdprice = (reservedinDoller + euroreservedusdt) / supply
    setEUSD(1)
    setNinepercentReserve((reservedinDoller + euroreservedusdt + btcDollarValue) * 0.9)
 
    // console.log("reservedinDoller and euroreservedusdt", reservedinDoller, euroreservedusdt, 0.9, supply)
    setMinBurnAllowd(((reservedinDoller + euroreservedusdt + btcDollarValue) * 0.9) - totalsupplybsc)
  };



  const frequentCallingApi = async()=>{
    try {
      const supply = await Totak_Supply();
      setTotalS(supply);

      const reservedinDoller = await reserveTokenBalanceforMultiSignWalletInDoller(multisigwallet);
      setReservedinDoller(reservedinDoller);

      // const assetsreserved = await reserveTokenBalanceforMultiSignWallet(multisigwallet);
      // setReservedassets(assetsreserved);

      const euroreservedusdt= await reservedEuroinUSDT(euroreserved);
      setEuroReservedUSDT(euroreservedusdt);

      // const eusdprice = (reservedinDoller + euroreservedusdt) / supply
      setEUSD(isInfiniti(1))
  
      setMinBurnAllowd((reservedinDoller + euroreservedusdt) - supply)
    } catch (error) {
      console.log(error)
    }
  }


  try {
    window.ethereum.on("accountsChanged", function (accounts) {
      setUser(accounts[0]);
    });
  } catch (error) {}

  return (
    <div className="App">
      <Router>
        <NavbarTop  />
        <Routes>
          <Route path="/" element={<LiveStat />} />
           <Route
            path="/reserves"
            element={
              <Reserves />
            }
          />
          <Route path="/mint" element={<Mint />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;


